// extracted by mini-css-extract-plugin
module.exports = {"transition-bg-container":"TransitionBackground_transition-bg-container__F44N_","children-container":"TransitionBackground_children-container__pf4ag"};